export enum BuildStatus {
	expired = 'expired',
	active = 'active',
}

export enum ForceType {
	Enforced = 'Enforced',
	Optional = 'Optional',
}
